const VerifyValidUrl = (url) => {
  try {

    const parsedURL = new URL(url)
    return parsedURL.protocol === "https:";

  } catch (e) {
    return false
  }
}

export default VerifyValidUrl